import Swiper, { Mousewheel, Navigation } from "swiper";

export default function () {
  /**
   * Query the existence of the target element. If the element does not
   * exist, stop executing the function.
   */

  let carousels = document.querySelectorAll(".swiper");

  if (!carousels) {
    return;
  }

  carousels.forEach((carousel) => {
    let id = carousel.id;

    if (carousel.classList.contains("c-carousel--article")) {
      const swiper = new Swiper(`#${id}.swiper`, {
        modules: [Navigation, Mousewheel],
        mousewheel: {
          forceToAxis: true,
        },
        navigation: {
          nextEl: `[data-swiper-id="${id}"] .c-carousel__button--next`,
          prevEl: `[data-swiper-id="${id}"] .c-carousel__button--prev`,
        },
        slidesPerView: 1.2,
        spaceBetween: 30,
        speed: 600,
      });
    } else if (carousel.classList.contains("c-carousel--logo")) {
      const swiper = new Swiper(`#${id}.swiper`, {
        modules: [Navigation, Mousewheel],
        mousewheel: {
          forceToAxis: true,
        },
        navigation: {
          nextEl: `[data-swiper-id="${id}"] .c-carousel__button--next`,
          prevEl: `[data-swiper-id="${id}"] .c-carousel__button--prev`,
        },
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 90,
        speed: 400,
        breakpoints: {
          500: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 90,
          },
          768: {
            slidesPerView: 4,
            slidesPerGroup: 4,
            speed: 600,
            spaceBetween: 120,
          },
          1400: {
            slidesPerView: 6,
            slidesPerGroup: 6,
            speed: 800,
            spaceBetween: 120,
          },
        },
      });
    } else if (carousel.classList.contains("c-carousel--list")) {
      const swiper = new Swiper(`#${id}.swiper`, {
        modules: [Mousewheel],
        mousewheel: {
          forceToAxis: true,
        },
        slidesPerView: 1.2,
        spaceBetween: 30,
        speed: 600,
        breakpoints: {
          1000: {
            slidesPerView: 2.4,
            slidesPerGroup: 2,
          },
          1400: {
            slidesPerView: 3.2,
            slidesPerGroup: 3,
          },
        },
      });
    } else if (carousel.classList.contains("c-carousel--image")) {
      const swiper = new Swiper(`#${id}.swiper`, {
        modules: [Navigation, Mousewheel],
        mousewheel: {
          forceToAxis: true,
        },
        navigation: {
          nextEl: `[data-swiper-id="${id}"] .c-carousel__button--next`,
          prevEl: `[data-swiper-id="${id}"] .c-carousel__button--prev`,
        },
        slidesPerView: 1.2,
        spaceBetween: 30,
        speed: 600,
        breakpoints: {
          600: {
            slidesPerView: 2.4,
            slidesPerGroup: 2,
          },
          1200: {
            slidesPerView: 4.2,
            slidesPerGroup: 3,
          },
        },
      });
    } else if (carousel.classList.contains("c-carousel--work")) {
      const swiper = new Swiper(`#${id}.swiper`, {
        modules: [Navigation],
        mousewheel: {
          forceToAxis: true,
        },
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        slidesPerView: 1.2,
        spaceBetween: 30,
        speed: 600,
        breakpoints: {
          600: {
            slidesPerView: 2,
          },
        },
      });
    } else {
      const swiper = new Swiper(`#${id}.swiper`, {
        modules: [Navigation, Mousewheel],
        mousewheel: {
          forceToAxis: true,
        },
        navigation: {
          nextEl: `[data-swiper-id="${id}"] .c-carousel__button--next`,
          prevEl: `[data-swiper-id="${id}"] .c-carousel__button--prev`,
        },
        slidesPerView: 1,
        spaceBetween: 60,
        speed: 400,
        breakpoints: {
          768: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          1200: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
        },
      });
    }
  });
}
